import useScrollTrigger from './useScrollTrigger'

export default useScrollTrigger
